import { render, staticRenderFns } from "./ProductCreator.vue?vue&type=template&id=71d6e0fc&scoped=true&"
import script from "./ProductCreator.vue?vue&type=script&lang=js&"
export * from "./ProductCreator.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreator.vue?vue&type=style&index=0&id=71d6e0fc&lang=scss&scoped=true&"
import style1 from "./ProductCreator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d6e0fc",
  null
  
)

export default component.exports